export default {
    getActivityLogs: (state) => state.activityLogs,
    getCurrentActivityLog: (state) => state.currentActivityLog,
};
